// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"80":"03d19d66","140":"62b328b3"}[chunkId] + ".chunk.js");